export default "__VITE_ASSET__CKyDAPZx__"